import { ClientsAPI } from "@/api/clients";
import websocket from "@/websocket";
import type {
  tBizClient,
  tCreateBizClientArgs,
  tUpdateBizClientArgs,
} from "@/types";
import { ClientMutationHandler } from "./mutationHandler";
import { ClientBoardsMutationHandler } from "./board/mutationHandler";
import { analyticsAction } from "@/utils/analytics";

export const ClientsService = {
  async createClient(data: tCreateBizClientArgs) {
    const { data: client } = await ClientsAPI.createClient(data);
    websocket.execIfNotConnected(() => {
      ClientMutationHandler.clientCreated({ client });
    });
    if (data.board) {
      analyticsAction({
        category: "funnel",
        action: "segment_client_added",
      });
    }
    websocket.execIfNotConnected(() => {
      ClientBoardsMutationHandler.clientAdded({
        master_id: client.master,
        saloon_id: client.saloon,
        client_id: client._id,
        list: data.board_list || "default",
        board_id: data.board,
        is_default_board: !data.board,
      });
    });
    return client;
  },
  async updateClient(id: string, data: tUpdateBizClientArgs) {
    const { data: client } = await ClientsAPI.updateClient(id, data);
    websocket.execIfNotConnected(() => {
      ClientMutationHandler.clientUpdated({ updated_client: client });
    });
    return client;
  },
  async removeClient(client: tBizClient) {
    await ClientsAPI.removeClient(client._id);
    websocket.execIfNotConnected(() => {
      ClientMutationHandler.clientRemoved({ client });
    });
    return client;
  },
};
